import { Component, Input, Output, EventEmitter, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ChatbotConnectionService {
    public createComponent(template: string): any {
        @Component({ template })
        class ChatbotComponent {
            public isDisabled = false;
            public isHidden = false;
            public chatbotConfig = {};

            @Output() public onEditLink = new EventEmitter();

            private dataValue: any;
            @Input()
            public set data(value) {
                this.dataValue = value;
            }
            public get data() {
                return this.dataValue;
            }
        }

        return ChatbotComponent;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/services/ChatbotConnectionService.service.ts